/*window.addEventListener('scroll', fixNav);
function fixNav() {
  const Header = document.querySelector('.header');
  if (window.scrollY > Header.offsetHeight - 110) {
    Header.classList.add('header--active')
  } else {
    Header.classList.remove('header--active')
  }
}*/
// Accessibilité du burger 
document.body.classList.toggle('js-enabled');

// Fermeture du menu
jQuery('.close_menu').click(function () {
  jQuery('.MenuFullWidth__content-wrapper').hide();
  jQuery('.close_menu').hide();
  jQuery('body').removeClass('burger-activated');
  jQuery('html').removeClass('menu-open');
});

// Ouverture du menu
jQuery('body').on('click', '.button--menu', function () {
  jQuery('body').addClass('burger-activated');
  jQuery('.close_menu').show();
  jQuery('.MenuFullWidth__content-wrapper').show();
  jQuery('html').addClass('menu-open'); 
  console.log('fadeIn');
});


// jQuery(document).ready(function($) {
//   // Fonction de toggle pour les filtres
//   $('.SidebarSearch__filters-item-header').click(function() {
//     var parentItem = $(this).closest('.SidebarSearch__filters-item');
    
//     // Toggle de la classe 'active'
//     parentItem.toggleClass('SidebarSearch__filters-item--active');
    
//     // SlideToggle pour ouvrir/fermer le contenu
//     parentItem.find('.SidebarSearch__filters-item-content').slideToggle();
//   });
// });

// document.getElementById('MobileFilter').addEventListener('click', function() {
//   document.body.classList.toggle('MobileFilter--activated');
// });